import * as React from 'react';

export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className="w-full rounded-lg border border-divider bg-white px-4 py-3 text-smallbody font-inter placeholder:text-weak/50 focus:outline-none focus:ring-2 focus:ring-primaryred"
    />
  );
}
